

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg mr-3">
                <i className="ri-car-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: '"Montserrat", sans-serif', fontWeight: '700', letterSpacing: '0.5px' }}>
                ALFA TRANSPORTES
              </h3>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Tu mejor opción para traslados confiables del aeropuerto a hoteles en Zihuatanejo. 
              Servicio profesional las 24 horas del día.
            </p>
            <div className="flex space-x-4">
              <a href="https://wa.me/5217551714622" className="w-10 h-10 flex items-center justify-center bg-green-600 rounded-lg hover:bg-green-700 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-white"></i>
              </a>
              <a href="mailto:alfatransport.mx@gmail.com" className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-mail-line text-white"></i>
              </a>
              <a href="tel:+5217551714622" className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-lg hover:bg-teal-700 transition-colors cursor-pointer">
                <i className="ri-phone-line text-white"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Traslados Aeropuerto-Hotel</li>
              <li>Traslados Hotel-Aeropuerto</li>
              <li>Transporte para Grupos</li>
              <li>Servicio 24/7</li>
              <li>Facturación WhatsApp</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                Zihuatanejo, Guerrero
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                +52 1 755 171 4622 / +52 1 755 131 2596
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                alfatransport.mx@gmail.com
              </li>
              <li className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                24/7 Disponible
              </li>
            </ul>
          </div>

        <div className="text-center md:text-left">
          <div className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, letterSpacing: '0.5px' }}>
            ALFA TRANSPORTES
          </div>
          <p className="text-blue-100 mb-4">
            Transporte Confiable en Ixtapa-Zihuatanejo
          </p>
          <p className="text-blue-200 text-sm">
            Tu mejor opción para traslados seguros y cómodos desde el Aeropuerto Internacional 
            de Ixtapa-Zihuatanejo hacia hoteles y destinos en toda la región.
          </p>
        </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 ALFA TRANSPORTES. Todos los derechos reservados. | 
            <a href="https://readdy.ai/?origin=logo" className="text-blue-400 hover:text-blue-300 ml-1 cursor-pointer">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

